import { render, staticRenderFns } from "./OtherFieldsDetails.vue?vue&type=template&id=363b457d&scoped=true&"
import script from "./OtherFieldsDetails.vue?vue&type=script&lang=js&"
export * from "./OtherFieldsDetails.vue?vue&type=script&lang=js&"
import style0 from "./OtherFieldsDetails.vue?vue&type=style&index=0&id=363b457d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b457d",
  null
  
)

export default component.exports